import axios from "axios";
import qs from "qs";
import constants from "../constants";
// import $ from 'jquery';

/**
 * các hàm dùng cho ký token = CA;
 */
export default {
  initConfig(config) {
    !config && (config = {});
    !config.paramsSerializer &&
      (config.paramsSerializer = function(params) {
        return qs.stringify(params, {
          arrayFormat: "repeat"
        });
      });
    !config.baseURL && (config.baseURL = constants.SIGN_TOKEN_BASE_SERVICE_URL);
    !config.headers && (config.headers = {});
    !config.timeout &&
      (config.timeout = constants.AXIOS_REQUEST_TIMEOUT * 1000);
    let header = config.headers;
    !header["Content-Type"] && (header["Content-Type"] = "application/json");
    return config;
  },

  get(url, config) {
    config = this.initConfig(config);
    return axios.get(url, config);
  },

  post(url, data, config) {
    config = this.initConfig(config);
    return axios.post(url, data, config);
  },

  getCert(mst) {
    return this.get("mobi/getcert", { params: { mst: mst } });
  },

  signPdf(cert, base64String) {
    let infoSign = {
      fileData: base64String,
      certSerial: cert.Serial,
      signDate: null,
      typeSign: "1"
    };
    return this.signPdfV2(infoSign);
  },

  signPdfV2(infoSign) {
    return this.post("mobi/signpdf", infoSign);
  }
};



// WEBPACK FOOTER //
// ./src/services/signTokenService.js